RFM_APP.controller("requestMilesThankyouController", ["$scope", "$state", "helper", "requestMilesService",  function ($scope, $state, helper, requestMilesService) {
    helper.updatePageTitle("pageTitle_confirmation_rfm");
    var airlinesData = requestMilesService.getAirlinesData();
    $scope.errorCode = requestMilesService.getMessageCodeForConfirmationPage();
    if ((airlinesData == null || airlinesData == '') && $scope.errorCode == null) {
    	$state.go('request');
    }
    
    $scope.backToSearch = function(){
        requestMilesService.clearPageErrorCodes();
        $state.go('request');
    }
    requestMilesService.addToWebAnalytics("page_name", "Request Flight Miles-Finish");
    requestMilesService.addToWebAnalytics("error_id", $scope.errorCode);
    requestMilesService.setMessageCodeForConfirmationPage(null);
    if (airlinesData != undefined || airlinesData != null || airlinesData != '') {
        requestMilesService.addToWebAnalytics("request_miles_airline", airlinesData);
    }
    requestMilesService.overrideSkipLinks();
    $scope.isSameUser = requestMilesService.isSameUser();
    $j("html,body").scrollTop(0);
}]);
